"use strict";

exports.__esModule = true;
exports.default = void 0;

var _tabs = require("./tabs");

var _tab = require("./tab");

var _plugins = require("../../utils/plugins");

var components = {
  BTabs: _tabs.default,
  BTab: _tab.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/tabs/index.js
// module id = T0hN
// module chunks = 14